import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from '@mui/material/TableHead';
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ConfirmationModal } from "components/organisms/ConfirmationModal";
import { useSelector } from "react-redux";
import { deleteSource } from "../helpers/Sources/deleteSource";
import "./step.css";
import UpdateSourceModal from "./UpdateSource.Modal";
import SwalAlertComp from "./SwalAlert";
import { ClipLoader } from "react-spinners";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import isSourceDeletable from "../helpers/source/isSourceDeletable";
import { Box, Tooltip } from "@mui/material";

const SourceTableContainerOld = ({
  Allsources,
  selectedItems,
  setSelectedItems,
  fetchSourceTestDetail,
  allSourceSDetails,
  setAllSourceSDetails,
  isTableLoading,
  getAllSourcesReduxProps,
  setNextCheck,
  getSourceIcon
}) => {
  const language = useSelector((state) => state.languagesState.languages);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingId, setPendingId] = useState(null);
  const [
    handleShowUpdateSourceModalState,
    setHandleShowUpdateSourceModalState,
  ] = useState(false);
  const [sourceName, setSourceName] = useState("");
  const [sourceId, setSourceId] = useState("");
  const [generic, setGeneric] = useState("");
  const [host, setHost] = useState("");
  const [sources, setSources] = useState("");
  const [openDetailId, setOpenDetailId] = useState(null);
  const getDomain = (id, name, host, is_generic, item) => {
    setSourceId(id);
    setSourceName(name);
    setHost(host);
    setGeneric(is_generic);
    setSources(item);
  };
  function handleOnChange(event, item) {
    const itemId = item.id;
    const sourceTypeId = item.source_type_id;
    const newSelectedItems = { ...selectedItems };

    // Eğer seçilen öğe source_type değeri 2 ise, birden çok seçilebilir
    if (sourceTypeId === 6) {
      if (event.target.checked) {
        newSelectedItems[itemId] = sourceTypeId;
      } else {
        delete newSelectedItems[itemId];
      }
    }
    // Eğer seçilen öğe source_type değeri 2 değilse, aynı source_type_id'ye sahip öğelerin seçimini düzenle
    else {
      const sameTypeItems = Object.entries(newSelectedItems).filter(
        ([key, value]) => value === sourceTypeId
      );

      // Aynı source_type_id'ye sahip başka bir öğe seçiliyse, seçimi kaldır
      if (sameTypeItems.length > 0) {
        const [firstItemId] = sameTypeItems[0];
        delete newSelectedItems[firstItemId];
      }

      if (event.target.checked) {
        newSelectedItems[itemId] = sourceTypeId;
      }
    }

    if(setNextCheck && Object.keys(newSelectedItems).length > 0){
      setNextCheck(true);
    }

    setSelectedItems(newSelectedItems);
  }

  const deleteSourceHandler = async (id) => {
    let response = await deleteSource(id);
    if (response.status) {
      SwalAlertComp({
        title: language?.delete_swal_modal?.success ?? "Success",
        message: response.message,
        icon: "success",
        timer: 3000,
      });
      getAllSourcesReduxProps();
      const copySelectedItems = { ...selectedItems };
      delete copySelectedItems[id];
      setSelectedItems(copySelectedItems);
    } else {
      SwalAlertComp({
        title: language?.delete_swal_modal?.failed ?? "Failed",
        message: response.message,
        icon: "error",
      });
    }
  };

  function toggleDetails(sourceId) {
    if (openDetailId === sourceId) {
      setOpenDetailId(null); // Kapatmak için tıklanan alanı tekrar tıklarsanız kapatır
      setAllSourceSDetails("");
    } else {
      setOpenDetailId(sourceId); // Farklı bir alanı açmak için tıkladığınızda bu alanı açar, diğerlerini kapatır
      setAllSourceSDetails("");
    }
  }

  const [SourcesList, SetSourcesList] = useState([]);
  const [AllSourcesList, SetAllSourcesList] = useState([]);
  const [ShowMoreStatus, SetShowMoreStatus] = useState(false);

  useEffect(() => {
    SetAllSourcesList([...Allsources]);
  }, [Allsources]);

  useEffect(() => {
    if(AllSourcesList.length > 0) {
      if(ShowMoreStatus === false){
        SetSourcesList([...AllSourcesList].slice(0, 3));
      }else{
        SetSourcesList([...AllSourcesList]);
      }
    } else {
      SetSourcesList([]);
    }
  }, [AllSourcesList]);

  const handleShowMore = () => {
    SetShowMoreStatus(true);
    SetSourcesList(Allsources);
  };

  function renderRows() {
    return (SourcesList &&
      SourcesList.length > 0 &&
      SourcesList.map((item) => {
        const isSelected = selectedItems[item.id] === item.source_type_id;
        const isDeletable = isSourceDeletable(item);

        return (
          <>
            <TableRow key={item.id}>
              <TableCell className="table-name-cell">
                <FormControlLabel control={<Checkbox checked={isSelected} onChange={(event) => handleOnChange(event, item)} />} label={item.name} />
              </TableCell>
              <TableCell>
                <div className="wizard-step-title">
                  <img className="source-icon" src={getSourceIcon(SourcesList, item?.source_type?.id)} />
                  {item?.source_type?.name ?? ""}
                </div>                
              </TableCell>
              <TableCell className="text-right">
              <Tooltip title={!isDeletable && 'Source is already in use !'} >

                <div className={`icon-area-old ${isDeletable ? '' : 'disabled'}`} >
                    <a
                      href="javascript:;"
                      className={`delete-icon ${isDeletable ? '' : 'disabled'}`}
                      onClick={() => {
                          if (isDeletable) {
                            setPendingId(item?.id ?? "");
                            setConfirmOpen(true);
                          }
                        }}
                        >
                        <DeleteOutlineIcon></DeleteOutlineIcon>
                    </a>
                </div>
                </Tooltip>
              </TableCell>
            </TableRow>
            {openDetailId === item.id && (
              <TableRow
                style={{ background: "#d2d2d2" }}
                key={`details-${item.id}`}
              >
                <TableCell colSpan={3}>
                  {" "}
                  <div style={{ maxHeight: "150px" }}>
                    {isTableLoading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <ClipLoader color="#729abf" size={50} />
                      </div>
                    ) : (
                      <div className="custom-scrollbar">
                        {allSourceSDetails &&
                          Object.keys(allSourceSDetails).map((key) => (
                            <p key={key}>
                              <b>{key}:</b> {allSourceSDetails[key]}
                            </p>
                          ))}
                      </div>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            )}
          </>
        );
      })
    );
  }

  const handleCloseUpdateSourceModal = () => {
    setHandleShowUpdateSourceModalState(false);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }} className="mui-modal-table-container">
      <ConfirmationModal
        open={confirmOpen}
        onClose={() => { setConfirmOpen(false); setPendingId(null); }}
        onConfirm={() => { deleteSourceHandler(pendingId); setConfirmOpen(false); setPendingId(null); }}
        title={language?.delete_swal_modal?.are_you_sure ?? "Are you sure?"}
        message="This action cannot be undone."
        confirmColor="error"
      />
      <TableContainer className="mui-modal-table" component={Paper} sx={{ maxHeight: "50dvh", overflowY: 'auto' }}>
        <Table
          stickyHeader 
          size="sm"          
          aria-label="a dense table"
          sx={{
            "& th": {
              fontSize: "1.25rem",
              color: "rgba(96, 96, 96)",
            },
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>{language?.add_source_modal?.source_name ?? "Source Name"}</TableCell>
              <TableCell>{language?.add_source_modal?.source_type ?? "Source Type"}</TableCell>
              <TableCell className="text-right">{language?.add_source_modal?.action ?? "Action"}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
              {renderRows()}
          </TableBody>
          {Allsources && Allsources.length > 3 && (ShowMoreStatus === false) && (
            <TableBody>
              <TableRow>
                <TableCell onClick={handleShowMore} colSpan={3}>
                  {ShowMoreStatus === false && (<div className="show-more-btn">
                    <span>Show More</span>
                    <FontAwesomeIcon icon={faAngleDown} />
                  </div>)}
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {handleShowUpdateSourceModalState && (
        <UpdateSourceModal
          handleCloseUpdateSourceModal={handleCloseUpdateSourceModal}
          setHandleShowUpdateSourceModalState={
            setHandleShowUpdateSourceModalState
          }
          sourceName={sourceName}
          sourceId={sourceId}
          sources={sources}
          generic={generic}
          host={host}
        />
      )}
    </Paper>
  );
};

export default SourceTableContainerOld;